module.exports = __webpack_public_path__ + "img/IDFC.4fb479cd.png";